import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import formatCurrency from "core/utils/currency";
import getOldPriceButtonText from "core/utils/getOldPriceButtonText";
import { useTranslation } from "react-i18next";
import PriceButton from "./PriceButton";

const PPV = "PPV";
const SUBSCRIPTION = "SUBSCRIPTION";
const DONATION = "DONATION";

export default function ProductPriceButton({ product, price, ...props }) {
  const { t } = useTranslation("arena");

  if (product.viewerPurchase) {
    return <PriceButton text={t("productPriceButton.open")} {...props} />;
  }

  if (!price) {
    return (
      <Button
        disableElevation
        fullWidth
        color="primary"
        size="large"
        sx={{ minHeight: 64 }}
        variant="outlined"
        {...props}
      >
        {t("productPriceButton.simpleOpen")}
      </Button>
    );
  }

  const value = formatCurrency(price.value, price.currency);

  if (product.type === DONATION) {
    return (
      <PriceButton
        // price={value}
        text={t("productPriceButton.donate")} // Donate {value}$
        {...props}
      />
    );
  }

  const oldPrice = getOldPriceButtonText(price);

  if (product.type === SUBSCRIPTION) {
    if (price.trialPeriod) {
      const count = price.trialPeriod;

      if (price.value) {
        return (
          <PriceButton
            oldPrice={oldPrice}
            price={value}
            text={t("productPriceButton.trialPrice", { count })} // {{count}} days for {value}$ {oldPrice}$
            {...props}
          />
        );
      }

      return (
        <PriceButton
          oldPrice={oldPrice}
          price={t("productPriceButton.free")}
          text={t("productPriceButton.freeTrial", { count })} // {{count}} days FREE TRIAL
          {...props}
        />
      );
    }
  }

  if (price.preOrder) {
    return (
      <PriceButton
        price={value}
        oldPrice={oldPrice}
        text={t("productPriceButton.preOrder")} // PRE-ORDER NOW {value}$ {oldPrice}$
        {...props}
      />
    );
  }

  if (price.nextPrice) {
    return (
      <PriceButton
        price={value}
        oldPrice={oldPrice}
        text={t("productPriceButton.buyNow")} // Buy now for {value}$
        {...props}
      />
    );
  }

  return <PriceButton price={value} oldPrice={oldPrice} {...props} />; // {value}$
}

ProductPriceButton.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf([SUBSCRIPTION, PPV, DONATION]).isRequired,
    viewerPurchase: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  price: PropTypes.shape({
    value: PropTypes.number.isRequired,
    trialPeriod: PropTypes.number,
    currency: PropTypes.string.isRequired,
    preOrder: PropTypes.bool,
    nextPrice: PropTypes.object,
  }).isRequired,
};
